// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"3ec83f98","281":"86cde529","472":"fbc3746d","497":"7a378661","527":"feaa48c3","603":"8e8b201f","709":"6ef25f58","899":"313c7fd1"}[chunkId] + ".chunk.js";
};